const commonSourceExtensions = ['ai', 'psd', 'prproj', 'aep', 'indd'];

export default commonSourceExtensions;
